document.addEventListener('DOMContentLoaded', () => {
  const sectionElement = document.getElementById('{{ section_id }}');
  if (!sectionElement) return;

  const dots = sectionElement.querySelectorAll('.testimonial-dot');
  const slider = sectionElement.querySelector('.testimonial-slider');

  if (!dots.length || !slider) return;

  // Function to update active dot
  const updateActiveDot = () => {
    const scrollLeft = slider.scrollLeft;
    const sliderWidth = slider.offsetWidth;
    // Find the slide closest to the center of the viewport
    const activeIndex = Math.round(scrollLeft / sliderWidth);

    dots.forEach((dot, index) => {
      if (index === activeIndex) {
        dot.style.backgroundColor = '{{ dots_active_color }}'; // Use style for active state
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.style.backgroundColor = '{{ dots_color }}'; // Inactive color
        dot.removeAttribute('aria-current');
      }
    });
  };

  // Dot click functionality
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      const targetSlide = sectionElement.querySelector(`#{{ section_id }}-slide-${index + 1}`);
      if (targetSlide) {
        const scrollPosition = targetSlide.offsetLeft - slider.offsetLeft;
        slider.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'
        });
      }
    });
  });

  // Update active dot on scroll and initial load
  let scrollTimer;
  slider.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateActiveDot, 150); // Debounce scroll event
  });

  // Intersection Observer for initial active dot when section scrolls into view
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                 updateActiveDot(); // Set initial dot when visible
                 // observer.unobserve(sectionElement); // Optional: Stop observing after first view
            }
        });
    }, { threshold: 0.1 }); // Trigger when 10% visible

    observer.observe(sectionElement);

});

/**
 * Expandable Text Snippet Controller
 *
 * Handles the "Read More" / "Read Less" functionality for text content
 * truncated by CSS line-clamping on mobile devices.
 */
class ExpandableText {
  constructor(wrapperElement) {
    this.wrapper = wrapperElement;
    this.content = this.wrapper.querySelector('[id^="content-"]');
    this.toggleBtn = this.wrapper.querySelector('[id^="toggle-"]');
    this.uniqueId = this.wrapper.dataset.expandableWrapper;

    if (!this.content || !this.toggleBtn) {
      console.warn('ExpandableText: Missing content or toggle button for ID:', this.uniqueId);
      return;
    }

    this.moreLabel = this.toggleBtn.dataset.moreLabel;
    this.lessLabel = this.toggleBtn.dataset.lessLabel;

    this.init();
  }

  init() {
    this.checkOverflowAndToggleVisibility();
    this.toggleBtn.addEventListener('click', this.toggleExpansion.bind(this));
    // Optional: Re-check on resize if layout shifts significantly
    window.addEventListener('resize', this.debounce(this.checkOverflowAndToggleVisibility.bind(this), 150));
  }

  isMobileView() {
    // Match the breakpoint used in your CSS (e.g., 749px)
    return window.matchMedia('(max-width: 749px)').matches;
  }

  checkOverflowAndToggleVisibility() {
    // Only check and potentially show the button on mobile views
    if (this.isMobileView()) {
      // Temporarily remove clamping to measure full height if needed,
      // but comparing scrollHeight and clientHeight often works directly.
      // Ensure styles are applied before checking. Using requestAnimationFrame can help.
      requestAnimationFrame(() => {
         const isClamped = this.content.scrollHeight > this.content.clientHeight;
         const isExpanded = this.content.classList.contains('is-expanded');

         // Show button only if content is overflowing AND not already expanded
         if (isClamped && !isExpanded) {
            this.toggleBtn.removeAttribute('hidden');
         } else {
           // Hide button if not overflowing (e.g., short text) or if already expanded
           // (unless we want 'Read Less' always visible when expanded)
           // Let's hide it if not overflowing, otherwise the toggle handles the text/state.
            if (!isClamped && !isExpanded) {
                 this.toggleBtn.setAttribute('hidden', true);
            } else if (isClamped) {
                // If it was overflowing and needs a button, ensure it's not hidden
                this.toggleBtn.removeAttribute('hidden');
            }
         }

         // Ensure correct initial state for ARIA and label if button is visible
         if (!this.toggleBtn.hasAttribute('hidden')) {
            const expanded = this.content.classList.contains('is-expanded');
            this.toggleBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            this.toggleBtn.textContent = expanded ? this.lessLabel : this.moreLabel;
         }
      });

    } else {
      // On desktop, always hide the button
      this.toggleBtn.setAttribute('hidden', true);
      // Optional: Ensure content is not marked as expanded on desktop if class persists
      // this.content.classList.remove('is-expanded');
    }
  }

  toggleExpansion() {
    const isCurrentlyExpanded = this.content.classList.toggle('is-expanded');

    this.toggleBtn.setAttribute('aria-expanded', isCurrentlyExpanded ? 'true' : 'false');
    this.toggleBtn.textContent = isCurrentlyExpanded ? this.lessLabel : this.moreLabel;

    // Optional: If you want the "Read Less" button to disappear when collapsed on mobile
    // this.checkOverflowAndToggleVisibility();
  }

  // Simple debounce function
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

// Initialize all instances on the page
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-expandable-wrapper]').forEach(wrapper => {
    new ExpandableText(wrapper);
  });
});

// Optional: Handle Shopify Theme Editor updates
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-expandable-wrapper]').forEach(wrapper => {
     // Check if already initialized (less common for section:load, more for blocks)
     // For simplicity, just re-init, or add a check
     new ExpandableText(wrapper);
  });
});

// You might also need shopify:block:select/deselect depending on usage